module.exports = __webpack_public_path__ + "static/img/6345_phase_function_Paper_PointsHejduk_Prediction.289da4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6345_phase_function_Paper_PointsHejduk_Prediction.png
// module id = V5Is
// module chunks = 0